import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const InternalUnstyledLink = (props) => (
  // Disabling rule for existing file because it's not worth the time to untangle this
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Link {...props} className={cn(styles.link, props.className)}>
    {props.children}
  </Link>
);

export default InternalUnstyledLink;

InternalUnstyledLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

InternalUnstyledLink.defaultProps = {
  className: '',
  children: null,
};
